// EVRTNG. Theme JS

(function () {
  'use strict';

  // ── Countdown Timer ──────────────────────────────────────────────────────
  function initCountdown() {
    var wrap = document.querySelector('.evr-countdown');
    if (!wrap) return;

    var raw = wrap.dataset.launch;
    if (!raw) return;

    // Parse as local midnight to avoid timezone offset issues
    var parts = raw.split('-');
    if (parts.length !== 3) return;
    var launchDate = new Date(
      parseInt(parts[0], 10),
      parseInt(parts[1], 10) - 1,
      parseInt(parts[2], 10)
    ).getTime();

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var now = Date.now();
      var diff = launchDate - now;

      if (diff <= 0) {
        var wrapEl = document.querySelector('.evr-countdown-wrap');
        if (wrapEl) wrapEl.remove();
        return;
      }

      var days    = Math.floor(diff / 86400000);
      var hours   = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000)  / 60000);
      var seconds = Math.floor((diff % 60000)    / 1000);

      var d = document.getElementById('evr-days');
      var h = document.getElementById('evr-hours');
      var m = document.getElementById('evr-mins');
      var s = document.getElementById('evr-secs');

      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(minutes);
      if (s) s.textContent = pad(seconds);
    }

    tick();
    setInterval(tick, 1000);
  }

  // ── Phone number formatting (loose) ──────────────────────────────────────
  function initPhoneFormat() {
    var input = document.getElementById('evr-phone');
    if (!input) return;

    input.addEventListener('input', function () {
      var digits = this.value.replace(/\D/g, '');
      this.value = digits;
    });
  }

  // ── Init ─────────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    initCountdown();
    initPhoneFormat();
  });
})();
